import Component from "../../../lib/component";
import { UsernameFieldConfig } from "./username_field";
import { JsonFetcher } from "../../../lib/json_fetcher";
import { POST_HTTP_METHOD } from "../../../helpers/request";
import iconTickSvg from "../assets/icon__tick.svg";
import iconCrossSvg from './../assets/icon__cross.svg';

export const UsernameIndicatorConfig = {
  componentTypeKey: "UsernameIndicator",
  baseHtmlClass: "signup_form__username_indicator",
  selector: ".signup_form__username_indicator",

  iconTickSvg: iconTickSvg,
  iconCrossSvg: iconCrossSvg,
};

export class UsernameIndicator extends Component {
  static get config() {
    return UsernameIndicatorConfig;
  }

  static createElement() {
    const element = document.createElement("p");
    element.classList.add(UsernameIndicator.config.baseHtmlClass);
    element.classList.add("inline-hints"); // Match Formtastic gem inline hints.
    return element;
  }

  constructor(id_or_element, usernameField, signupForm) {
    super({
      element: id_or_element,
      config: UsernameIndicator.config,
    });

    this.signupForm = signupForm;
    this.usernameField = usernameField;

    // Get some config from the signupForm.
    const config = this.signupForm.usernameIndicatorConfig;
    this.usernamesEndpoint = config["usernames_endpoint"];
    this.apiKey = config["api_key"];
    this.usernamePlaceholder = config["placeholder_token"];
    this.minUsernameLength = !!config["min_length"] ? parseInt(config["min_length"]) : 0;
    this.maxUsernameLength = !!config["max_length"] ? parseInt(config["max_length"]) : 0;
    this.usernameRegex = new RegExp(config["regex"]);

    this.isFetching = false;
    this.hadResponse = false;
    this.isValid = false;

    this.usernameField.handleEvent(
      UsernameFieldConfig.changedUsernameEventName,
      this.handleUsernameChanged.bind(this),
    );

    this.render();
  }

  handleUsernameChanged(event) {
    const username = event.memo?.username;

    // If the username is not valid then we don't need to make a request to the server.
    if (!this.isUsernameValid(username)) {
      this.hadResponse = true;
      this.responseUsername = username;
      this.responseMessage = `The username ${this.usernamePlaceholder} is not valid`;
      this.responseIsTaken = false;
      this.responseIsValid = false;
      this.render();
      return;
    }

    // If there is no endpoint or API key then we don't need to make a request to the server.
    if (!this.usernamesEndpoint || !this.apiKey) return;

    this.isFetching = true;
    const options = {
      httpMethod: POST_HTTP_METHOD,
      timeoutCallback: this.timeoutCallback,
      timeout: 5000,
    };
    const params = {
      api_key: this.apiKey,
      username: username,
    };
    new JsonFetcher(this.usernamesEndpoint, options)
      .fetchData(params)
      .then((responseData) => {
        this.hadResponse = true;
        this.responseUsername = responseData["username"];
        this.responseMessage = responseData["message"];
        this.responseIsTaken = !!responseData["is_taken"];
        this.responseIsValid = !!responseData["is_valid"];
      })
      .finally(() => {
        this.isFetching = false;
        this.render();
      });
    this.render();
  }

  timeoutCallback(responseData) {
    console.warn(
      "[UsernameIndicator] timeoutCallback() responseData:",
      responseData,
    );
  }

  render() {
    this.swapHtmlClassStates(
      this.responseUsernameMatchesCurrent(),
      "current",
      "not_current",
    );
    this.conditionallySetHtmlClassState(this.isFetching, "is_fetching");
    this.conditionallySetHtmlClassState(this.hadResponse, "had_response");
    this.swapHtmlClassStates(this.responseIsTaken, "taken", "available");
    this.swapHtmlClassStates(this.responseIsValid, "valid", "invalid");
    this.swapHtmlClassStates(this.isGoodResponse(), "good", "bad");
    this.element.innerHTML = this.renderContent();
  }

  responseUsernameMatchesCurrent() {
    return this.getCurrentUsername() === this.responseUsername;
  }

  getCurrentUsername() {
    return this.usernameField.getValue();
  }

  renderContent() {
    const icon = this.isGoodResponse() ? UsernameIndicator.config.iconTickSvg : UsernameIndicator.config.iconCrossSvg;
    return `${icon}<span>${this.renderMessage()}</span>`;
  }

  renderMessage() {
    if (!this.responseMessage) return "";
    return `${this.responseMessage.replace(
      this.usernamePlaceholder,
      `<em>${this.responseUsername}</em>`,
    )}`;
  }

    isGoodResponse() {
        return this.responseIsValid && !this.responseIsTaken;
    }

  // This mirrors the server-side validation of a username (see Username#valid? in app/models/username.rb)
  isUsernameValid(username) {
    if (!username) return false;
    if (username.length < this.minUsernameLength) return false;
    if (username.length > this.maxUsernameLength) return false;
    return this.usernameRegex.test(username);
  }

}

